import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function Sidebar() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const [isBrandOpen, setIsBrandOpen] = useState(false);
  const [isOrderOpen, setIsOrderOpen] = useState(false);
  const [isProductOpen, setIsProductOpen] = useState(false);
  const [isCouponOpen, setIsCouponOpen] = useState(false);
  const [isSellerOpen, setIsSellerOpen] = useState(false);
  const [isResellerOpen, setIsResellerOpen] = useState(false);

  const toggleSellerDropdown = () => {
    setIsSellerOpen(!isSellerOpen);
  };
   const toggleResellerDropdown = () => {
     setIsResellerOpen(!isResellerOpen);
   };
  const toggleCouponDropdown = () => {
    setIsCouponOpen(!isCouponOpen);
  };

  const toggleProductDropdown = () => {
    setIsProductOpen(!isProductOpen);
  };

  const toggleOrderDropdown = () => {
    setIsOrderOpen(!isOrderOpen);
  };

  const toggleBrandDropdown = () => {
    setIsBrandOpen(!isBrandOpen);
  };

  const toggleCategoryDropdown = () => {
    setIsCategoryOpen(!isCategoryOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/");
  };

  const toggleDropdown = () => setIsOpen(!isOpen);
  return (
    <div id="layoutSidenav">
      <div id="layoutSidenav_nav">
        <nav
          className="sb-sidenav accordion sb-sidenav-dark"
          id="sidenavAccordion"
        >
          <div className="sb-sidenav-menu">
            <div className="nav">
              <div className="sb-sidenav-menu-heading">Core</div>

              <div className="nav-link" onClick={toggleOrderDropdown}>
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Order Management
                <div className="sb-sidenav-collapse-arrow">
                  <i
                    className={`fas ${
                      isOrderOpen ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </div>
              </div>

              {isOrderOpen && (
                <nav className="sb-sidenav-menu-nested nav">
                  <Link className="nav-link" to="/admin/dashboard">
                    New Order
                  </Link>
                  <Link className="nav-link" to="/admin/DropdownOfStatus">
                    Update Order Status
                  </Link>
                  <Link className="nav-link" to="/admin/ProcessingData">
                    Processing Order
                  </Link>
                  <Link className="nav-link" to="/admin/CodOrders">
                    Cod Order
                  </Link>
                  <Link className="nav-link" to="/admin/CodSales">
                    Cod Sales Report
                  </Link>
                  <Link className="nav-link" to="/admin/SalesReport">
                    Prepaid Sales Report
                  </Link>
                </nav>
              )}

              <div className="nav-link" onClick={toggleCategoryDropdown}>
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Category / Subcategory
                <div className="sb-sidenav-collapse-arrow">
                  <i
                    className={`fas ${
                      isCategoryOpen ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </div>
              </div>

              {/* Dropdown content */}
              {isCategoryOpen && (
                <nav className="sb-sidenav-menu-nested nav">
                  <Link className="nav-link" to="/admin/add-Category">
                    Add Category
                  </Link>
                  <Link className="nav-link" to="/admin/AddSubCategory">
                    Add Subcategory
                  </Link>
                  <Link className="nav-link" to="/admin/ViewCategory">
                    View Category
                  </Link>
                  <Link className="nav-link" to="/admin/ViewSubcategory">
                    View Subcategory
                  </Link>
                </nav>
              )}

              <div className="nav-link" onClick={toggleBrandDropdown}>
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Brand
                <div className="sb-sidenav-collapse-arrow">
                  <i
                    className={`fas ${
                      isBrandOpen ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </div>
              </div>
              {isBrandOpen && (
                <nav className="sb-sidenav-menu-nested nav">
                  <Link className="nav-link" to="/admin/AddBrand">
                    Add Brand
                  </Link>
                  <Link className="nav-link" to="/admin/GetAllBrands">
                    View Brand
                  </Link>
                </nav>
              )}

              <div className="nav-link" onClick={toggleDropdown}>
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Specification
                <div className="sb-sidenav-collapse-arrow">
                  <i
                    className={`fas ${
                      isOpen ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </div>
              </div>

              {isOpen && (
                <nav className="sb-sidenav-menu-nested nav">
                  <Link className="nav-link" to="/admin/AddSpecifications">
                    Add Specification
                  </Link>
                  <Link
                    className="nav-link"
                    to="/admin/GetAllspecificationkeys"
                  >
                    View Specification
                  </Link>
                </nav>
              )}

              <div className="nav-link" onClick={toggleProductDropdown}>
                <div className="sb-nav-link-icon">
                  <i className="fas fa-columns"></i>
                </div>
                Product
                <div className="sb-sidenav-collapse-arrow">
                  <i
                    className={`fas ${
                      isProductOpen ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </div>
              </div>

              {isProductOpen && (
                <nav className="sb-sidenav-menu-nested nav">
                  <Link className="nav-link" to="/admin/AddProduct">
                    Add Product
                  </Link>
                  <Link className="nav-link" to="/admin/ViewProduct">
                    View Product
                  </Link>
                  <Link className="nav-link" to="/admin/ImageUploading">
                    Image Uploading
                  </Link>
                  <Link className="nav-link" to="/admin/ViewImages">
                    View Image
                  </Link>
                  <Link className="nav-link" to="/admin/AddPromotionalImg">
                    Add Promotional Image
                  </Link>
                  <Link className="nav-link" to="/admin/ViewPromotional">
                    View Promotional Image
                  </Link>
                  <Link className="nav-link" to="/admin/ViewTrandingProduct">
                    View Trending Product
                  </Link>
                  <Link className="nav-link" to="/admin/BulkProductUpload">
                    Bulk Product Upload
                  </Link>
                </nav>
              )}

              <div className="nav-link" onClick={toggleCouponDropdown}>
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Coupon & Sale
                <div className="sb-sidenav-collapse-arrow">
                  <i
                    className={`fas ${
                      isCouponOpen ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </div>
              </div>

              {isCouponOpen && (
                <nav className="sb-sidenav-menu-nested nav">
                  <Link className="nav-link" to="/admin/AddCoupon">
                    Add Coupon
                  </Link>
                  <Link className="nav-link" to="/admin/GetCoupon">
                    View Coupon
                  </Link>
                  <Link className="nav-link" to="/admin/AddFlashSale">
                    Add FlashSale
                  </Link>
                  <Link className="nav-link" to="/admin/GetFlashSale">
                    View FlashSale
                  </Link>
                  <Link className="nav-link" to="/admin/ReferralFeature">
                    Add Free Gift
                  </Link>
                  <Link className="nav-link" to="/admin/GiftProductDetails">
                    View Gift
                  </Link>
                </nav>
              )}

              {/* <Link className="nav-link" to="/admin/GetAllSeller">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                All Seller
              </Link> */}

              <div className="nav-link" onClick={toggleSellerDropdown}>
                <div className="sb-nav-link-icon">
                  <i className="fas fa-users"></i>
                </div>
                Seller
                <div className="sb-sidenav-collapse-arrow">
                  <i
                    className={`fas ${isSellerOpen ? "fa-angle-up" : "fa-angle-down"}`}
                  ></i>
                </div>
              </div>

              {isSellerOpen && (
                <nav className="sb-sidenav-menu-nested nav">
                  <Link className="nav-link" to="/admin/GetAllSeller">
                    Get All Seller
                  </Link>
                  <Link className="nav-link" to="/admin/SellerCommission">
                    Seller Commission
                  </Link>
                  <Link className="nav-link" to="/admin/SellerProducts">
                    Seller Products
                  </Link>
                  <Link className="nav-link" to="/admin/AdminWithdrawRequests">
                    Seller Withdraw Requests
                  </Link>
                  <Link className="nav-link" to="/admin/ReleaseHoldAmount">
                    ReleaseHoldAmount
                  </Link>
                  <Link className="nav-link" to="/admin/GetAllSellerOrder">
                    GetAllSellerOrder
                  </Link>

                  {/* ReleaseHoldAmount */}
                </nav>
              )}

              <div className="nav-link" onClick={toggleResellerDropdown}>
                <div className="sb-nav-link-icon">
                  <i className="fas fa-users"></i>
                </div>
                Reseller
                <div className="sb-sidenav-collapse-arrow">
                  <i
                    className={`fas ${isResellerOpen ? "fa-angle-up" : "fa-angle-down"}`}
                  ></i>
                </div>
              </div>

              {isResellerOpen && (
                <nav className="sb-sidenav-menu-nested nav">
                  <Link className="nav-link" to="/admin/GetAllReSeller">
                    Get All Reseller
                  </Link>
                  <Link
                    className="nav-link"
                    to="/admin/ResellerWithdrawRequests"
                  >
                    Reseller Withdraw Requests
                  </Link>
                  <Link className="nav-link" to="/admin/ReleaseHoldAmountRe">
                    ReleaseHoldAmount
                  </Link>
                  <Link className="nav-link" to="/admin/ResellerProducts">
                    ResellerProducts
                  </Link>
                  <Link className="nav-link" to="/admin/GetAllResellerOrder">
                    GetAllResellerOrder
                  </Link>
                </nav>
              )}

              {/* AdminWallet */}

              <Link className="nav-link" to="/admin/AdminWallet">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-wallet"></i>
                </div>
                Admin Wallet
              </Link>

              <Link className="nav-link" to="/admin/Profile">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Users
              </Link>
              <Link className="nav-link" to="/admin/reports">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Reports
              </Link>
              <Link className="nav-link" to="/admin/AddNotification">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Add Notification
              </Link>
              <Link className="nav-link" to="/admin/UpdateVersion">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Update Version
              </Link>
              <Link className="nav-link" to="/admin/AddDeliveryCost">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Add Delivery Cost
              </Link>
              <Link className="nav-link" to="/admin/AddBankDetails">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                Add Bank Details
              </Link>
              <Link className="nav-link" to="/admin/Analytics">
                <div className="sb-nav-link-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </div>
                App Analytics
              </Link>

              <button className="logout-button" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
          <div className="sb-sidenav-footer">
            <div className="small">Logged in as:</div>
            Admin
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Sidebar;
